
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import { useLanguage } from "@/context/LanguageContext";
import { Star } from "lucide-react";
import { useState } from "react";

interface RatingFieldProps {
  form: UseFormReturn<any>;
}

export const RatingField = ({ form }: RatingFieldProps) => {
  const { t, language } = useLanguage();
  const [hoveredRating, setHoveredRating] = useState<number | null>(null);
  const currentRating = form.watch("rating") || 0;
  
  return (
    <FormField
      control={form.control}
      name="rating"
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {language === 'en' ? 'Rating' : '評分'}
            <span className="text-destructive ml-1">*</span>
          </FormLabel>
          <FormControl>
            <div className="flex items-center">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  className={`cursor-pointer transition-colors ${
                    (hoveredRating !== null ? hoveredRating >= star : currentRating >= star)
                      ? "fill-yellow-400 text-yellow-400"
                      : "text-gray-300"
                  }`}
                  size={32}
                  onClick={() => {
                    field.onChange(star);
                    form.setValue("rating", star);
                  }}
                  onMouseEnter={() => setHoveredRating(star)}
                  onMouseLeave={() => setHoveredRating(null)}
                />
              ))}
            </div>
          </FormControl>
          <div className="text-xs text-muted-foreground pt-1">
            {language === 'en' ? 'Click to select rating' : '點擊以選擇評分'}
          </div>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
